import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontDocuments from './documents';
import waiter from '../img/wait.svg'
import FrontFooter from './footer'
import download from '../img/file-download-line.png'
import FrontProgress from './progress';

export default class FrontSubscribedSolly extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox front_form">
                <div className="contentvbox">
                <h1 className="top_title">
                    Merci pour votre souscription
                </h1>
                <p>&nbsp;</p>
                <p>
                    Vous avez choisi de souscrire à l'offre de notre partenaire.
                    Nous vous invitons à vous rendre sur le site 
                    &nbsp;<a href="https://assurbonplan.fr/">https://assurbonplan.fr/</a> pour
                    suivre votre dossier.
                </p>

                <h2>Ou contactez nous par téléphone</h2>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>

                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>

            </div>

            </div>
            <FrontFooter/>

        </>
    }
}